import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TeamStatusTable from './../components/TeamStatusTableV2';
import { getTeamVolunteerData } from '../actions/reportsActions';
import { getSeasonDivisions } from '../actions/divisionsActions';

const mapDispatchToProps = dispatch => {
  return {
    getTeamVolunteerData: (seasonId) => {
      dispatch(getTeamVolunteerData(seasonId));
    },
    getSeasonDivisions: (seasonId) => {
      dispatch(getSeasonDivisions(seasonId));
    },
  };
};

const mapStateToProps = state => ({
  userSeason: state.user.userSeason,
  teams: state.reports.teams,
  teamsList: state.reports.teamsList,
  fetchingTeamVolunteerDataStatus: state.reports.fetchingTeamVolunteerDataStatus,
  seasonDivisions: state.divisions.seasonDivisions,
  seasonDivisionsList: state.divisions.seasonDivisionsList,
  fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus
});

const TeamStatusTableContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(TeamStatusTable));
export default TeamStatusTableContainer;



// WEBPACK FOOTER //
// ./src/containers/TeamStatusTableContainer.js